import CryptoJS from 'crypto-js'

const AES_KEY = CryptoJS.enc.Utf8.parse('qUGi03RMyvZrbakt')
const AES_IV = CryptoJS.enc.Utf8.parse('TmhwC30eK1KZ3_kV')

export function encryptPayload(payload: unknown) {
  const content = typeof payload === 'string' ? payload : JSON.stringify(payload ?? {})
  return CryptoJS.AES.encrypt(content, AES_KEY, {
    iv: AES_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

export function decryptPayload<T = unknown>(payload: string): T {
  const decrypted = CryptoJS.AES.decrypt(payload, AES_KEY, {
    iv: AES_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8)

  try {
    return JSON.parse(decrypted) as T
  } catch {
    return decrypted as T
  }
}